import React, { useEffect, useState } from 'react';
import api from '../../../utils/axios';
import { CheckCircle2, AlertTriangle, XCircle, CircleDashed, Radio } from 'lucide-react';

export const ESTADO_META = {
  actualizado: { label: 'Actualizado', icon: CheckCircle2, text: 'text-emerald-700', bg: 'bg-emerald-100', dot: 'bg-emerald-500', hex: '#10b981', grad: 'from-emerald-500 to-teal-500' },
  atrasado: { label: 'Atrasado', icon: AlertTriangle, text: 'text-amber-700', bg: 'bg-amber-100', dot: 'bg-amber-500', hex: '#f59e0b', grad: 'from-amber-500 to-orange-500' },
  desactualizado: { label: 'Desactualizado', icon: XCircle, text: 'text-rose-700', bg: 'bg-rose-100', dot: 'bg-rose-500', hex: '#f43f5e', grad: 'from-rose-500 to-red-500' },
  sin_datos: { label: 'Sin datos', icon: CircleDashed, text: 'text-slate-600', bg: 'bg-slate-100', dot: 'bg-slate-400', hex: '#94a3b8', grad: 'from-slate-400 to-slate-500' },
  en_vivo: { label: 'En vivo', icon: Radio, text: 'text-sky-700', bg: 'bg-sky-100', dot: 'bg-sky-500', hex: '#0ea5e9', grad: 'from-sky-500 to-cyan-500' },
};

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
export const fmtPeriodoCorto = (p) => {
  if (!p) return '—';
  const [y, m] = p.split('-');
  return `${MESES[parseInt(m, 10) - 1]}-${y.slice(2)}`;
};

export const SectionStatusChip = ({ seccionKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    let ok = true;
    api.get(`/kpis/estado/${seccionKey}`).then((r) => ok && setS(r.data)).catch(() => {});
    return () => { ok = false; };
  }, [seccionKey]);
  if (!s || !s.estado) return null;
  const meta = ESTADO_META[s.estado] || ESTADO_META.sin_datos;
  const Icon = meta.icon;
  const label = s.en_vivo ? 'En vivo' : `${meta.label}${s.ultimo_periodo ? ` · ${fmtPeriodoCorto(s.ultimo_periodo)}` : ''}`;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${meta.bg} ${meta.text}`}
      data-testid={`section-status-${seccionKey}`}
      title="Estado de actualización de los datos de esta sección"
    >
      <Icon size={13} />
      {label}
      {s.tiene_error && <AlertTriangle size={12} className="text-rose-600" title="La última corrida automática tuvo un error" />}
    </span>
  );
};
